import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SEO from '../utils/SEO';
import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';
import ConcertListingBannerBlock from '../components/complex/concertListingBannerBlock/concertListingBannerBlock';
import CalendarHeader from '../components/complex/calendarHeader/calendarHeader';
import ConcertCardList from '../components/complex/concertCardList/concertCardList';
import { startLoader } from '../components/common/Loader';

function ConcertListing ({
  getMeta,
  match,
  upcomingConcertsList,
  pastConcertsList,
  getConcerts,
  getPastConcerts,
  ...props
}) {
  const [concerts, setConcerts] = useState(null);
  const [pastConcerts, setPastConcerts] = useState([]);
  const [banner, setBanner] = useState(null);
  const [concertProgram, setConcertProgram] = useState(null);

  useEffect(() => {
    getMeta('Concerts');
    if (JSON.stringify(upcomingConcertsList) !== JSON.stringify({})) {
      startLoader(false);
      setBanner(upcomingConcertsList?.items?.banner);
      setConcerts(upcomingConcertsList?.items?.data);
      setConcertProgram(upcomingConcertsList?.items?.document);
      setPastConcerts(pastConcertsList?.items?.data);
    } else {
      startLoader();
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (JSON.stringify(upcomingConcertsList) === JSON.stringify({})) {
        const upcomingRes = await getConcerts('upcoming');

        setBanner(upcomingRes.res.banner);
        setConcerts(upcomingRes.res.data);
        setConcertProgram(upcomingRes.res.document);
      }

      if (JSON.stringify(pastConcertsList) === JSON.stringify({})) {
        const pastRes = await getPastConcerts('past');
        setPastConcerts(await pastRes.res.data);
      }
    })();
  }, []);

  const metaData = props.metaData?.res;
  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
      <ConcertListingBannerBlock bannerData={banner !== null && banner} />

      <div className='calendar-body' id='calendar-body'>
        <CalendarHeader
          concertProgram={
            concertProgram && Object.keys(concertProgram).length
              ? concertProgram
              : {}
          }
          data={concerts && concerts.length ? concerts : []}
        />
        <ConcertCardList data={concerts && concerts.length ? concerts : []} />
      </div>

      {pastConcerts && pastConcerts.length ? (
        <div className='calendar-body past' id='calendar-past-body'>
          <CalendarHeader concertProgram={{}} data={[]} past />
          <ConcertCardList data={pastConcerts} />
        </div>
      ) : (
        ''
      )}
    </>
  );
}

function mapState (state) {
  return {
    upcomingConcertsList: state.getConcerts,
    pastConcertsList: state.getPastConcerts,
    metaData: state.getMeta,
  };
}

ConcertListing.propTypes = {
  getMeta: PropTypes.func,
  match: PropTypes.object,
  upcomingConcertsList: PropTypes.object,
  pastConcertsList: PropTypes.object,
  getConcerts: PropTypes.func,
  getPastConcerts: PropTypes.func,
};

const actionCreators = {
  getConcerts: (status) => userActions.getConcerts(status),
  getPastConcerts: (status) => userActions.getPastConcerts(status),
  getMeta: userActions.getMetaData,
};
ConcertListing.fetchMeta = () => actionCreators.getMeta('Concerts');

export default connect(mapState, actionCreators)(ConcertListing);
